import ContactUsHero from "./ContactUsPage";


function Contactus() {
  return (
    <div>
        <ContactUsHero/>
    </div>
  );
}

export default Contactus;
